/* eslint-disable */
import React from "react";
import { usePermission } from "hooks/usePermission";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import { resolvePortalPath, stripPortalBasePath } from "utils/portalPath";
import { MdToggleOn, MdToggleOff } from "react-icons/md";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes, onMenuClick, autoCloseOnMobile, onToggleAutoClose } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    const currentPath = stripPortalBasePath(location.pathname).replace(/^\/+|\/+$/g, "");
    if (routeName === "lead-management") {
      return currentPath.startsWith("lead-management");
    }
    if (routeName === "client-management") {
      return currentPath.startsWith("client-management");
    }
    if (routeName === "careof-management") {
      return currentPath.startsWith("careof-management");
    }
    if (routeName === "staff-management") {
      return currentPath.startsWith("staff-management");
    }
    if (routeName === "folders/leads") {
      return /^folders\/leads(?:\/|$)/.test(currentPath);
    }
    if (routeName === "folders/clients") {
      return /^folders\/clients(?:\/|$)/.test(currentPath);
    }
    if (routeName === "folders") {
      return currentPath === "folders" || currentPath.startsWith("folders/");
    }
    return currentPath === routeName;
  };

  const { user } = useUser();
  const portalRole = user?.role;

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      // Skip hidden routes
      if (route.hidden) return null;

      // Map certain route paths to permission module keys
      const routeModuleMap = {
        "dashboard": "dashboard",
        "calendar": "calendar",
        "careof-management": "careof_management",
        "lead-management": "lead_management",
        "client-management": "client_management",
        "staff-management": "staff_management",
        "folders": "lead_folder",
      };

      const { getAccessible } = usePermission();
      const accessible = getAccessible();

      const moduleKey = routeModuleMap[route.path];
      // If a mapping exists and user doesn't have access to this module, skip route
      if (moduleKey && !accessible.includes(moduleKey)) return null;

      if (
        route.layout === "/admin" ||
        route.layout === "/auth"
      ) {
        const isActive = activeRoute(route.path);
        const routeHref =
          route.layout === "/admin"
            ? resolvePortalPath(route.path, portalRole)
            : `${route.layout}/${route.path}`;

        return (
          <Link
            key={index}
            to={routeHref}
            onClick={onMenuClick}
          >
            <li
              className={`relative mb-2 flex w-full cursor-pointer items-center gap-3 rounded-xl px-4 py-3 transition-all duration-300 ease-in-out ${isActive
                  ? "bg-gray-100 dark:bg-navy-700"
                  : "hover:bg-gray-100 dark:hover:bg-navy-700"
                }`}
              key={index}
            >
              <span
                className={`flex items-center justify-center transition-all duration-300 ease-in-out ${isActive
                    ? "font-bold text-brand-500 dark:text-white"
                    : "font-medium text-gray-600 group-hover:text-navy-700 dark:text-gray-400 dark:hover:text-white"
                  }`}
              >
                {route.icon ? route.icon : <DashIcon />}
              </span>
              <p
                className={`leading-1 flex flex-1 transition-all duration-300 ease-in-out ${isActive
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600 dark:text-gray-400 group-hover:text-navy-700 dark:hover:text-white"
                  }`}
              >
                {route.name}
              </p>
              {isActive && (
                <div className="absolute right-0 top-1/2 h-9 w-1 -translate-y-1/2 rounded-lg bg-brand-500 dark:bg-brand-400 transition-all duration-300 ease-in-out" />
              )}
            </li>
          </Link>
        );
      }
    });
  };

  const links = createLinks(routes);

  return (
    <>
      {links}

      {/* Auto-close toggle - Only visible on mobile, after Sign In */}
      {onToggleAutoClose && (
        <div className="xl:hidden border-t border-gray-200 px-4 pt-4 dark:border-white/10">
          <button
            onClick={onToggleAutoClose}
            className="flex w-full items-center gap-3 rounded-xl px-4 py-3 transition-all duration-300 ease-in-out hover:bg-gray-100 dark:hover:bg-navy-700"
            title="Toggle: Auto-close menu after selecting an item (Mobile only)"
          >
            {autoCloseOnMobile ? (
              <MdToggleOn className="text-2xl text-brand-500 transition-all duration-300 ease-in-out" />
            ) : (
              <MdToggleOff className="text-2xl text-gray-400 dark:text-gray-600 transition-all duration-300 ease-in-out" />
            )}
            <div className="flex-1 text-left">
              <p className="text-xs font-semibold text-gray-600 dark:text-gray-300 transition-all duration-300 ease-in-out">
                {autoCloseOnMobile ? "Auto-close: ON" : "Auto-close: OFF"}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {autoCloseOnMobile ? "Menu closes after selecting" : "Menu stays open"}
              </p>
            </div>
          </button>
        </div>
      )}
    </>
  );
}

export default SidebarLinks;
